import React from "react";
import "./spinner.scss";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";

const Spinner = ({ open = false, absolute = false, isWhite = false }) => {
  return (
    <Backdrop
      open={open}
      style={{
        position: absolute ? "absolute" : "fixed",
        zIndex: 100000,
        backgroundColor: isWhite ? "rgb(255 255 255 / 50%)" : "rgb(0 0 0 / 50%)"
      }}
    >
      <CircularProgress color="primary" />
    </Backdrop>
  );
};
export default Spinner;
